/* B2FPV theme — product gallery, variant picker, print color, quantity, small helpers */
(function () {
  'use strict';

  /* ---------- Helpers ---------- */
  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var value = (cents / 100);
    function withDelims(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }

  function decode(str) {
    var t = document.createElement('textarea');
    t.innerHTML = str || '';
    return t.value;
  }

  /* ---------- Gallery ---------- */
  function showMedia(section, mediaId) {
    if (!section || !mediaId) return;
    var slides = section.querySelectorAll('.gallery-slide');
    var thumbs = section.querySelectorAll('[data-thumb]');
    var found = false;
    slides.forEach(function (s) {
      if (s.getAttribute('data-media-id') === String(mediaId)) found = true;
    });
    if (!found) return;
    slides.forEach(function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(mediaId));
    });
    thumbs.forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(mediaId));
    });
  }

  /* ---------- Print color (single color + multi-color 3-part setup), saved as line item properties ---------- */
  function setDot(sel) {
    var dot = sel && sel.parentNode.querySelector('[data-pc-dot]');
    if (!dot) return;
    var opt = sel.options[sel.selectedIndex];
    var bg = opt && opt.getAttribute('data-swatch');
    dot.style.background = bg || '';
    dot.classList.toggle('is-empty', !bg);
  }

  function multiState(section) {
    var box = section.querySelector('[data-print-color]');
    var slotsDone = true;
    if (box) {
      box.querySelectorAll('[data-pc-slot]').forEach(function (sel) { if (!sel.value) slotsDone = false; });
    }
    var notes = box && box.querySelector('[data-pc-notes]');
    var notesFilled = !!(notes && notes.value.trim().length >= 3);
    return { slotsDone: slotsDone, notesFilled: notesFilled };
  }

  function syncPrintColor(section, variantTitle) {
    if (!section) return;
    var box = section.querySelector('[data-print-color]');
    var hidden = section.querySelector('[data-pc-hidden]');
    if (!box || !hidden) return;

    var showWhen = (box.getAttribute('data-show-when') || '').toLowerCase().trim();
    var multiKey = (box.getAttribute('data-multi-keyword') || '').toLowerCase().trim();
    if (typeof variantTitle === 'string') {
      var t = variantTitle.toLowerCase();
      box.setAttribute('data-active', (!showWhen || t.indexOf(showWhen) !== -1) ? 'true' : 'false');
      box.setAttribute('data-multi', (multiKey && t.indexOf(multiKey) !== -1) ? 'true' : 'false');
    }
    var active = box.getAttribute('data-active') === 'true';
    var multi = box.getAttribute('data-multi') === 'true' && !!box.querySelector('[data-pc-multi]');

    box.hidden = !(active || multi);
    var single = box.querySelector('[data-pc-single]');
    if (single) single.hidden = !active;
    var singleCallout = box.querySelector('[data-pc-single-callout]');
    if (singleCallout) singleCallout.hidden = multi || !active;
    var panel = box.querySelector('[data-pc-multi]');
    if (panel) panel.hidden = !multi;

    /* keep the multi swatch / dropdown option in step with the selected variant */
    var multiRadio = box.querySelector('[data-pc-multi-radio]');
    if (multiRadio) {
      if (multi) multiRadio.checked = true;
      else if (multiRadio.checked) multiRadio.checked = false;
    }
    var select = box.querySelector('[data-pc-select]');
    if (select) {
      if (multi) select.value = '__multi__';
      else if (select.value === '__multi__') select.value = '';
      setDot(select);
    }

    var radio = box.querySelector('[data-pc-radio]:checked');
    var value = multi ? 'Multi-Color' : (select ? select.value : (radio ? radio.value : ''));
    if (value === '__multi__') value = '';
    hidden.value = value;
    hidden.disabled = box.hidden || !value;

    var picked = box.querySelector('[data-pc-selected]');
    if (picked && value) picked.textContent = value;

    box.querySelectorAll('[data-pc-slot]').forEach(function (sel) {
      setDot(sel);
      var name = sel.getAttribute('data-pc-slot');
      section.querySelectorAll('[data-pc-slot-hidden]').forEach(function (h) {
        if (h.getAttribute('data-pc-slot-hidden') === name) {
          h.value = sel.value;
          h.disabled = !multi || !sel.value;
        }
      });
    });

    var notes = box.querySelector('[data-pc-notes]');
    var notesHidden = section.querySelector('[data-pc-notes-hidden]');
    if (notes && notesHidden) {
      notesHidden.value = notes.value.trim();
      notesHidden.disabled = box.hidden || !notesHidden.value;
    }

    var ms = multiState(section);
    if (value || multi) {
      var err = box.querySelector('[data-pc-error]');
      if (err) err.hidden = true;
    }
    if (!multi || ms.slotsDone || ms.notesFilled) {
      var merr = box.querySelector('[data-pc-multi-error]');
      if (merr) merr.hidden = true;
    }
    if ((value || multi) && (!multi || ms.slotsDone || ms.notesFilled)) box.classList.remove('has-error');

    var form = hidden.form;
    if (form) {
      var needsColor = (active && !multi && box.getAttribute('data-required') === 'true' && !value) ||
        (multi && !ms.slotsDone && !ms.notesFilled);
      form.classList.toggle('needs-print-color', needsColor);
    }
  }

  function printColorMissing(section) {
    var box = section && section.querySelector('[data-print-color]');
    if (!box || box.hidden) return false;
    var multi = box.getAttribute('data-multi') === 'true' && !!box.querySelector('[data-pc-multi]');
    var active = box.getAttribute('data-active') === 'true';
    var focusEl = null;

    if (multi) {
      var ms = multiState(section);
      if (ms.slotsDone || ms.notesFilled) return false;
      var merr = box.querySelector('[data-pc-multi-error]');
      if (merr) merr.hidden = false;
      box.querySelectorAll('[data-pc-slot]').forEach(function (sel) { if (!focusEl && !sel.value) focusEl = sel; });
    } else {
      if (!active || box.getAttribute('data-required') !== 'true') return false;
      var select = box.querySelector('[data-pc-select]');
      if (select && select.value) return false;
      if (box.querySelector('[data-pc-radio]:checked')) return false;
      var err = box.querySelector('[data-pc-error]');
      if (err) err.hidden = false;
      focusEl = select || box.querySelector('[data-pc-radio]');
    }
    box.classList.add('has-error');
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (focusEl) focusEl.focus({ preventScroll: true });
    return true;
  }

  /* Switch the variant picker to (or away from) the matching Multi-Color option */
  function stripMulti(v) {
    return v.replace(/\s*\(?\s*multi[\s-]?colou?r\s*\)?\s*/i, ' ').trim().toLowerCase();
  }

  function toggleMulti(section, on) {
    var box = section.querySelector('[data-print-color]');
    var key = ((box && box.getAttribute('data-multi-keyword')) || 'multi').toLowerCase().trim();
    var picker = section.querySelector('[data-variant-picker]');
    if (!picker || !key) return false;
    var sets = Array.prototype.slice.call(picker.querySelectorAll('fieldset'));
    var target = null;

    sets.forEach(function (fs) {
      if (target) return;
      var cur = fs.querySelector('input:checked');
      if (!cur) return;
      var curV = cur.value.toLowerCase();
      var inputs = Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]'));
      if (on && curV.indexOf(key) === -1) {
        target = inputs.find(function (i) {
          var v = i.value.toLowerCase();
          return v.indexOf(key) !== -1 && stripMulti(i.value) === curV;
        }) || null;
      } else if (!on && curV.indexOf(key) !== -1) {
        var plain = stripMulti(cur.value);
        target = inputs.find(function (i) { return i.value.toLowerCase() === plain; }) ||
          inputs.find(function (i) { return i.value.toLowerCase().indexOf('single') !== -1; }) ||
          inputs.find(function (i) { return i.value.toLowerCase().indexOf(key) === -1; }) || null;
      }
    });

    if (!target && on) {
      /* e.g. a separate "Print Style: Single / Multi-Color" option */
      sets.forEach(function (fs) {
        if (target) return;
        var cur = fs.querySelector('input:checked');
        if (cur && cur.value.toLowerCase().indexOf(key) !== -1) return;
        target = Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]')).find(function (i) {
          return i.value.toLowerCase().indexOf(key) !== -1;
        }) || null;
      });
    }

    if (!target) return false;
    target.checked = true;
    target.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function onPrintColorPick(input) {
    var section = input.closest('[data-product-section]');
    var box = section && section.querySelector('[data-print-color]');
    if (!box) return;
    var isMultiPick = input.value === '__multi__';
    var multiNow = box.getAttribute('data-multi') === 'true';
    if (isMultiPick && !multiNow) {
      if (!toggleMulti(section, true)) syncPrintColor(section);
      return;
    }
    if (!isMultiPick && multiNow && (input.matches('[data-pc-radio]') || input.matches('[data-pc-select]'))) {
      toggleMulti(section, false);
    }
    syncPrintColor(section);
  }

  /* ---------- Variant selection ---------- */
  function getVariants(section) {
    if (section._variants !== undefined) return section._variants;
    var el = section.querySelector('[data-variants-json]');
    try { section._variants = el ? JSON.parse(el.textContent) : null; }
    catch (e) { section._variants = null; }
    return section._variants;
  }

  function selectedValues(section) {
    var picker = section.querySelector('[data-variant-picker]');
    if (!picker) return [];
    return Array.prototype.map.call(picker.querySelectorAll('fieldset'), function (fs) {
      var c = fs.querySelector('input:checked');
      return c ? { value: c.value, id: c.getAttribute('data-option-value-id') } : null;
    });
  }

  function applyVariant(section, variant) {
    var format = decode(section.getAttribute('data-money-format'));

    var idInput = section.querySelector('[data-variant-id-input]');
    if (idInput) idInput.value = variant.id;

    var price = section.querySelector('[data-price]');
    if (price) price.textContent = formatMoney(variant.price, format);

    var compare = section.querySelector('[data-compare-price]');
    if (compare) {
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      compare.hidden = !onSale;
      if (onSale) compare.textContent = formatMoney(variant.compare_at_price, format);
    }

    var btn = section.querySelector('[data-add-btn]');
    if (btn) {
      btn.disabled = !variant.available;
      btn.textContent = variant.available
        ? 'Add to cart · ' + formatMoney(variant.price, format)
        : 'Sold out';
    }

    if (variant.featured_media && variant.featured_media.id) {
      showMedia(section, variant.featured_media.id);
    }

    syncPrintColor(section, variant.title || '');

    if (window.history && window.history.replaceState) {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', u.toString());
    }
  }

  /* Fallback for products with more variants than fit in the page JSON */
  var pending = null;
  function fetchVariant(section, ids) {
    var sectionId = section.getAttribute('data-section-id');
    var url = section.getAttribute('data-product-url');
    if (pending) pending.abort();
    pending = new AbortController();
    fetch(url + '?section_id=' + encodeURIComponent(sectionId) + '&option_values=' + ids.join(','), { signal: pending.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-product-info]');
        if (!fresh) return;
        var variantId = fresh.getAttribute('data-variant-id');
        var priceEl = fresh.querySelector('[data-price]');
        var btnEl = fresh.querySelector('[data-add-btn]');
        var idInput = section.querySelector('[data-variant-id-input]');
        if (idInput && variantId) idInput.value = variantId;
        var price = section.querySelector('[data-price]');
        if (price && priceEl) price.textContent = priceEl.textContent;
        var btn = section.querySelector('[data-add-btn]');
        if (btn && btnEl) { btn.disabled = btnEl.disabled; btn.textContent = btnEl.textContent; }
        var mediaId = fresh.getAttribute('data-featured-media');
        if (mediaId) showMedia(section, mediaId);
        var title = fresh.getAttribute('data-variant-title');
        syncPrintColor(section, title);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        console.error('[B2FPV] Variant update failed', err);
      });
  }

  function onOptionChange(input) {
    var section = input.closest('[data-product-section]');
    if (!section) return;

    var label = input.closest('fieldset').querySelector('.option-selected');
    if (label) label.textContent = input.value;

    var picked = selectedValues(section);
    var variants = getVariants(section);
    var match = null;
    if (variants) {
      match = variants.find(function (v) {
        return picked.every(function (p, i) { return p && v.options[i] === p.value; });
      });
    }

    if (match) {
      applyVariant(section, match);
    } else {
      fetchVariant(section, picked.filter(Boolean).map(function (p) { return p.id; }));
    }
  }

  /* ---------- Events ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      showMedia(thumb.closest('[data-product-section]'), thumb.getAttribute('data-thumb'));
      return;
    }

    var qtyBtn = e.target.closest('[data-qty]');
    if (qtyBtn) {
      var wrap = qtyBtn.closest('.qty');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var next = (parseInt(input.value, 10) || 1) + parseInt(qtyBtn.getAttribute('data-qty'), 10);
      input.value = Math.max(1, next);
      return;
    }

    var link = e.target.closest('.menu-drawer-nav a');
    if (link) {
      var d = link.closest('details');
      if (d) d.removeAttribute('open');
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target;

    if (input.matches('select[data-auto-submit]')) {
      input.form.submit();
      return;
    }

    if (input.matches('input[data-auto-update]')) {
      var btn = input.form && input.form.querySelector('button[name="update"]');
      if (btn) btn.click();
      return;
    }

    if (input.matches('[data-pc-select], [data-pc-radio]')) {
      onPrintColorPick(input);
      return;
    }

    if (input.matches('[data-pc-notes], [data-pc-slot]')) {
      syncPrintColor(input.closest('[data-product-section]'));
      return;
    }

    if (input.matches('[data-variant-picker] input[type="radio"]')) {
      onOptionChange(input);
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-pc-notes]')) syncPrintColor(e.target.closest('[data-product-section]'));
  });

  /* Block add to cart until a required print color is chosen */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('.product-form')) return;
    var section = form.closest('[data-product-section]');
    syncPrintColor(section);
    if (printColorMissing(section)) e.preventDefault();
  });

  /* Make sure the hidden print-color fields match the page on load */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-section]').forEach(function (section) {
      syncPrintColor(section);
    });
  });

  /* ---------- Build gallery: filters + detail popups ---------- */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-build-gallery] [data-filter]');
    if (pill) {
      var gallery = pill.closest('[data-build-gallery]');
      var f = pill.getAttribute('data-filter');
      gallery.querySelectorAll('[data-filter]').forEach(function (p) {
        var on = p === pill;
        p.classList.toggle('pill--active', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var shown = 0;
      gallery.querySelectorAll('[data-build]').forEach(function (card) {
        var ok = f === 'all' ||
          (f.indexOf('frame:') === 0 && card.getAttribute('data-frame') === f.slice(6)) ||
          (f.indexOf('type:') === 0 && card.getAttribute('data-type') === f.slice(5));
        card.hidden = !ok;
        if (ok) shown++;
      });
      var empty = gallery.querySelector('[data-build-empty]');
      if (empty) empty.hidden = shown > 0;
      return;
    }

    var opener = e.target.closest('[data-open-build]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-open-build'));
      if (dlg && dlg.showModal) dlg.showModal();
      return;
    }

    if (e.target.closest('[data-close-build]')) {
      var d = e.target.closest('dialog');
      if (d) d.close();
      return;
    }

    /* click on the dark backdrop closes the popup */
    if (e.target.matches && e.target.matches('dialog.bg-dialog')) {
      e.target.close();
    }
  });
})();
